"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHTMLElements = exports.getPreservedObjs = exports.removeEventListeners = exports.applyFns = exports.getFns = exports.isPreservedObj = exports.mappedProp = exports.isObjectOrArray = void 0;
var isObjectOrArray = function (val) {
    return val instanceof Object || val instanceof Array;
};
exports.isObjectOrArray = isObjectOrArray;
var mappedProp = function (propMap, key) {
    var filteredMap = propMap.filter(function (prop) { return prop.reactProp === key; });
    return filteredMap[0] || null;
};
exports.mappedProp = mappedProp;
var isPreservedObj = function (key, value, preservedObjs) { return preservedObjs.includes(key) && (0, exports.isObjectOrArray)(value); };
exports.isPreservedObj = isPreservedObj;
var getFns = function (props, customMapping) {
    return Object.keys(props)
        .filter(function (key) { return typeof props[key] === 'function'; })
        .map(function (key) {
        var mapped = (0, exports.mappedProp)(customMapping, key);
        var eventFn = function (customEvent) {
            return props[key](customEvent.detail, customEvent);
        };
        return {
            event: (mapped === null || mapped === void 0 ? void 0 : mapped.event) || false,
            key: (mapped === null || mapped === void 0 ? void 0 : mapped.wcProp) || key,
            fn: (mapped === null || mapped === void 0 ? void 0 : mapped.event) ? eventFn : props[key],
        };
    });
};
exports.getFns = getFns;
var applyFns = function (fns, current) {
    fns.forEach(function (_a) {
        var event = _a.event, key = _a.key, fn = _a.fn;
        event ? current.addEventListener(key, fn) : (current[key] = fn);
    });
};
exports.applyFns = applyFns;
var removeEventListeners = function (fns, current) {
    if (current) {
        fns.forEach(function (_a) {
            var event = _a.event, key = _a.key, fn = _a.fn;
            if (event)
                current.removeEventListener(key, fn);
        });
    }
};
exports.removeEventListeners = removeEventListeners;
var getPreservedObjs = function (props, preservedObjs) {
    return Object.keys(props)
        .filter(function (key) { return (0, exports.isPreservedObj)(key, props[key], preservedObjs); })
        .map(function (key) { return ({
        key: key,
        value: props[key],
    }); });
};
exports.getPreservedObjs = getPreservedObjs;
var getHTMLElements = function (props) {
    return Object.keys(props)
        .filter(function (key) {
        return props[key] instanceof Node || props[key] instanceof HTMLElement;
    })
        .map(function (key) { return ({
        key: key,
        el: props[key],
    }); });
};
exports.getHTMLElements = getHTMLElements;
//# sourceMappingURL=helpers.js.map